export default "__VITE_ASSET__1fe854c3__"